export default {
  props: {
    // Vue 2 contract compatibility (`value` + `input`) for custom components.
    value: {
      default: undefined,
    },
  },
  // Declare the events this mixin emits so Vue 3 does NOT also bind `@input` / `@update:modelValue`
  // as native fallthrough listeners on the consumer's root element. Without this, a bubbled native
  // `input` event fires the listener a second time (e.g. checkbox selections toggling back to off).
  // Merged into each consuming component's own `emits`.
  emits: ['update:modelValue', 'input'],
  computed: {
    modelCompatValue() {
      return this.value !== undefined ? this.value : this.modelValue;
    },
  },
  methods: {
    // Forward exactly the arguments the caller provided — value, plus the native event when one
    // is passed (e.g. AppOnOffToggle) — so value-only callers keep the Vue 2 `$emit('input', value)`
    // shape instead of emitting a trailing `undefined`.
    emitModelCompatValue(...args) {
      this.$emit('update:modelValue', ...args);
      this.$emit('input', ...args);
    },
  },
};
